// extracted by mini-css-extract-plugin
module.exports = {"comp":"OnePicture_comp__ojE2J"};